"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("../index.less");
var _index2 = _interopRequireDefault(require("@/components/reTitle/index"));
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      backPath: '/teacherIndex',
      tabsActNum: 0,
      titleInfo: {},
      newTypeList: [],
      reNewsInfo: [],
      totalNum: 0,
      page: {
        pageSize: 12,
        pageNumber: 1
      },
      actID: ''
    };
  },
  methods: {
    // 获取新闻类型
    getNewsType: function getNewsType() {
      var _this = this;
      (0, _news.newsTypeByCode)({
        param: this.prCode
      }).then(function (res) {
        if (res.data.length > 0) {
          _this.newTypeList = res.data;
          _this.actID = _this.newTypeList[0].id;
          _this.findNews();
        }
      });
    },
    //根据ID查新闻列表
    findNews: function findNews() {
      var _this2 = this;
      (0, _news.newsListByCodeAndType)({
        code: this.prCode,
        newsTypeId: this.actID,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        _this2.reNewsInfo = res.data.list;
        _this2.totalNum = res.data.total;
      });
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.findNews();
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.findNews();
    },
    tabs: function tabs(index, id) {
      this.tabsActNum = index;
      this.actID = id;
      this.findNews();
    },
    lookDetail: function lookDetail(id, url) {
      if (url) {
        window.open(url);
      } else {
        this.$router.push({
          path: "/teacherNewsDetail",
          query: {
            id: id
          }
        });
      }
    }
  },
  created: function created() {
    var v = this.$route;
    this.titleInfo.sec = v.meta.title;
    this.titleInfo.path = v.fullPath;
    this.getNewsType();
  },
  components: {
    RealTitle: _index2.default
  }
};